
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './fourofourpage.scss';








const Pfourofourpage = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id693320a88e5aed52dc8aab2b" >

      <div id="ikmz" className="">
      
      <div id="iodg" className="">
      
      <img
        className=""
        id="iype8"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiqbbqw7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i00j" className="">
      
      <div id="iuxs" className="">
      
      <div className="" id="i7gm6">
        <>404</>
      </div>
      <>
        </>
      </div>
      
      <div id="iwd3d" className="">
      
      <div className="" id="i5lir">
        <>Parece que el enlace que buscabas no existe o fue movido.</>
      </div>
      <>
        </>
      </div>
      
      <div id="iwukb" className="">
      
        <a
          target=""
          className=""
          id="ie74h"
          href={`/`}
        >
          
      <span className="" id="irvau">
        <>Regresar A Inicio</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="icdg" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pfourofourpage);
  